'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'deer';
var width = 512;
var height = 512;
var aliases = [129420];
var unicode = 'f78e';
var svgPathData = ['M16 264l0 24.8c3.8 7.5 9.2 14.1 16 19.3l0-23.4c3 4.8 7 9 11.8 12.2l24.6 16.4 3.6 2.4 0 37.6-.4 1.2-15.2 45.6 29.5 95.9 71.3 0-28.8-93.6-1.8-5.7 5-3.3 43.7-29.1c-5.4-32.3-8.9-53.5-10.6-63.5 7.3 5.8 25.3 20.3 54.1 43.3l77.2 0 0 152 72 0 0-185.6c0-5 .7-9.9 2-14.7l22.3-81.8 1.6-5.9 102.1 0 0-36.7-91.3-91.3-58.8 0-73.9 36.9 0 11.1 72 0 0 16-8.6 0-15 42.7-1.9 5.3-230.6 0c-39.8 0-72 32.2-72 72zM416 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M240 8l0-8-16 0 0 32c0 26.5 21.5 48 48 48l38.1 0-49.7 24.8-4.4 2.2 0 36.9 62.5 0-11.3 32-219.2 0c-48.6 0-88 39.4-88 88l0 56 16 0 0-56c0-39.8 32.2-72 72-72l230.6 0 1.9-5.3 15-42.7 8.6 0 0-16-72 0 0-11.1 73.9-36.9 58.8 0 91.3 91.3 0 36.7-102.1 0-1.6 5.9-22.3 81.8c-1.3 4.8-2 9.8-2 14.7l0 185.6-72 0 0-152-77.2 0c-28.8-23-46.8-37.5-54.1-43.3 1.7 10 5.2 31.2 10.6 63.5l-43.7 29.1-5 3.3 1.8 5.7 28.8 93.6-71.3 0-29.5-95.9 15.2-45.6 .4-1.2 0-37.6-3.6-2.4-24.6-16.4C39 293.7 35 289.5 32 284.7l0 23.4c1 .7 1.9 1.4 3 2.1l21 14 0 26.4-15.6 46.8-.8 2.4 .8 2.5 32 104 1.7 5.6 104.7 0-3.2-10.4-30.2-98.3 43-28.7 4.3-2.9-.9-5.1-4.6-27.4 23.7 18.9 2.2 1.8 66.8 0 0 152 104 0 0-201.6c0-3.6 .5-7.1 1.4-10.5l20.7-75.9 105.9 0 0-59.3-2.3-2.3-82.4-82.4C452.2 78.2 472 57.4 472 32l0-32-16 0 0 32c0 17.7-14.3 32-32 32l-84.2 0c7.6-8.5 12.2-19.7 12.2-32l0-32-16 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-24zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDeer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;